import React, { Component } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import TimelineIcon from '@material-ui/icons/Timeline';
import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import BallotIcon from '@material-ui/icons/BallotOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import Popover from '@material-ui/core/Popover';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import FilterListIcon from '@material-ui/icons/FilterList';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import UpdateIcon from '@material-ui/icons/Update';
import {getObjectives} from '../../../../services/getObjectives';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CompareIcon from '@material-ui/icons/Compare';


import SummaryObjectives from '../../../../views/Dashboard/components/SummaryObjectives';


// Component styles
import styles from './styles';
import { api_host } from '../../../../common/globals/constants';
import { Grid } from '@material-ui/core';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')
const dateMoment=((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listaObjetivos: {},
            listaObjetivosOnline: {},
            listaServicios: {},
            cargando: true,
            anchorEl: null,
            checked: [],
            checkedBase: 0,
            isBallotIconChecked: false,
            setChecked: [],
            token:sessionStorage.getItem('key'),
            user:sessionStorage.getItem("user"),
            openModal: false,
            dateMoment:(moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"),
            isUpdated: false,
            profileId: sessionStorage.getItem('profile_id'),
            special:false,
            listObjectivesSpecials:[],
            nameSide:"Monitoreos"
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.dateMoment!== this.state.dateMoment || this.state.isUpdated||prevState.special!==this.state.special){
            //console.log('up sidebar')
            this.componentDidMount()
        }
    }

    componentDidMount() {
        const {special}=this.state
        let token = sessionStorage.getItem('key')
        let user_id = sessionStorage.getItem('user')
        if(special===true){
            fetch(api_host + `/reporte/online/indicadores/getObjetivesType/?user=${user_id}&token=${token}&type=especiales`)
            .then(response => response.json())
            .then(myJson => {
                if (myJson.status === 1 || myJson.status === 5) {
                    localStorage.setItem('isAuthenticated', false);   
                } else {
                    myJson=(myJson.map(data => ({
                        ...data,
                        nombre: data.nombre.replaceAll("/", "|")
                    })))
                    this.props.callbackFromParent(myJson)
                    sessionStorage.setItem('special', "true")
                    sessionStorage.setItem('specials', JSON.stringify(myJson))
                    this.setState({
                        listObjectivesSpecials:myJson,
                        cargando:false,
                        nameSide:"R.Especiales"
                    });  
                }
            })
        }else if(sessionStorage.getItem('special')==="true"){
            this.props.callbackFromParent(JSON.parse(sessionStorage.getItem('specials')))
            this.setState({
                listObjectivesSpecials:JSON.parse(sessionStorage.getItem('specials')),
                special:true,
                cargando:false,
                nameSide:"R.Especiales"
            });
        }else{
            if(!sessionStorage.getItem('horarios')){
                fetch(api_host + `/reporte/general/horarios/?token=${token}&hour=business`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        sessionStorage.setItem('horarios', JSON.stringify(myJson))
                    }
                })
            }

            if(sessionStorage.getItem("listsLoads")==="true"){
                //console.log('cache de objetivos')
                var dataSession=JSON.parse(sessionStorage.getItem("listaData"))
                var seriesSession=JSON.parse(sessionStorage.getItem("listaObjetivosOnline"))
                var servicesSession=JSON.parse(sessionStorage.getItem("dataServices"))
                var checked=JSON.parse(sessionStorage.getItem("checked"))
                this.props.callbackFromParent(dataSession)
                if(sessionStorage.getItem("isLoadAvailability")==="true"){
                    //console.log('cache con disponibilidad')
                    var dataUptime=(JSON.parse(sessionStorage.getItem("listaDataAvailability")))
                    var UptimeObjs=[]
                    var DownObjs=[]
                    var PartialObj=[]
                    dataUptime.map(Obj=>{
                        
                        if(Obj.estado==="Uptime"){
                            UptimeObjs.push(Obj)
                        }else if(Obj.estado==="Downtime"){
                            DownObjs.push(Obj)
                        }else if(Obj.estado==="Parcial"){
                            PartialObj.push(Obj)
                        }
                    })
                    UptimeObjs.sort(function (a, b) {
                        return (a.disponibilidad - b.disponibilidad);
                    })
                    DownObjs.sort(function (a, b) {
                        return (a.disponibilidad - b.disponibilidad);
                    })
                    PartialObj.sort(function (a, b) {
                        return (a.disponibilidad - b.disponibilidad);
                    })
                    UptimeObjs.sort(function (a, b) {
                        var nombreA = (a.nombre).toLowerCase()
                        var nombreB = (b.nombre).toLowerCase()
                        if (nombreA < nombreB) return -1;
                        if (nombreA > nombreB) return 1;
                        return 0;
                    })
                    DownObjs.sort(function (a, b) {
                        var nombreA = (a.nombre).toLowerCase()
                        var nombreB = (b.nombre).toLowerCase()
                        if (nombreA < nombreB) return -1;
                        if (nombreA > nombreB) return 1;
                        return 0;
                    })
                    PartialObj.sort(function (a, b) {
                        var nombreA = (a.nombre).toLowerCase()
                        var nombreB = (b.nombre).toLowerCase()
                        if (nombreA < nombreB) return -1;
                        if (nombreA > nombreB) return 1;
                        return 0;
                    })
                    dataSession.Uptime=UptimeObjs
                    dataSession.Downtime=DownObjs
                    dataSession.Partial=PartialObj
                    seriesSession=[].concat(DownObjs, PartialObj, UptimeObjs, dataSession.NoMonitoring)
                    
                }
                this.setState({
                    listaObjetivos: (dataSession),
                    listaObjetivosOnline: seriesSession,
                    filteredListObjectives: seriesSession,
                    listaServicios: servicesSession,
                    cargando: false,
                    checked: checked,
                    checkedBase: checked.length,
                    isUpdated: false,
                    nameSide:"Monitoreos"
                });  
            }else{
                //console.log('carga sin cache')
                getObjectives(user_id, token).then(data=>{
                    if (data.status === 1 || data.status === 5) {
                        localStorage.setItem('isAuthenticated', false);   
                    } else {
                        let dataSeries = []
                        let dataServices = []
                        let checked = []
                        
                        dataServices.push('Todos')
                        checked.push(0)
                        Object.keys(data).map((keyType) => {
                            if (keyType != 'Services' && keyType != 'ServicesUnified') {
                                let serie = data[keyType]
                                Object.keys(serie).map((key) => {
                                    serie[key].nombre=(serie[key].nombre.replace("/", "|"))
                                    dataSeries.unshift(serie[key])
                                })
                            } else if (keyType == 'ServicesUnified') {                            
                                let serie = data[keyType]
                                Object.keys(serie).map((key) => {
                                    checked.push(parseInt(key)+1)
                                    dataServices.push(serie[key])
                                })
                            }
                        })
                        this.props.callbackFromParent(data)
                        localStorage.setItem('isLoadObjectiveList', true);
                        var order = {'Downtime': 1, "Parcial": 2, "Uptime": 3, "No monitoreo": 4};
                        dataSeries.sort(function (a, b) {
                            var priorityA = order[a.estado] || Infinity;
                            var priorityB = order[b.estado] || Infinity;

                            var nombreA = (a.nombre).toLowerCase()
                            var nombreB = (b.nombre).toLowerCase()

                            if (priorityA < priorityB) return -1;
                            if (priorityA > priorityB) return 1;

                            if (nombreA < nombreB) return -1;
                            if (nombreA > nombreB) return 1;
                            return 0;
                        })
                        this.setState({
                            listaObjetivos: (data),
                            listaObjetivosOnline: dataSeries,
                            filteredListObjectives: dataSeries,
                            listaServicios: dataServices,
                            cargando: false,
                            checked: checked,
                            checkedBase: checked.length,
                            isUpdated: false,
                            nameSide:"Monitoreos"
                        });
                        sessionStorage.setItem("listaData",JSON.stringify(data))
                        sessionStorage.setItem("listaObjetivosOnline",JSON.stringify(dataSeries))
                        sessionStorage.setItem("dataServices",JSON.stringify(dataServices))
                        sessionStorage.setItem("checked",JSON.stringify(checked))
                        sessionStorage.setItem("listsLoads",true)
                    }
                })
            }
        }
        
        this.interval = setInterval(() => this.setState({ dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")) }), 300000);
    }

    handleClick = event => {
        this.setState({
            anchorEl: event.currentTarget
        });
    };

    handleClose = () => {
        this.setState({
            anchorEl: null
        });
    };
    handleClickModal = event => {            
        if (this.state.openModal == false){
            this.setState({
                openModal: true,
            })
        }        
    };
    
    handleCloseModal = event => {   
        this.setState({
            openModal: false,  
        })
    };

    handleClickUpdate = event => {   
        sessionStorage.setItem("listsLoads", false)
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        this.setState({
            cargando: true,
            isUpdated: true,  
        })
    };

    handleToggle = value => () => {
        const {checked, listaServicios, listaObjetivosOnline, checkedBase} = this.state
        const currentIndex = checked.indexOf(parseInt(value));
        const newChecked = [...checked];
        var check = false

        if (parseInt(value) == 0){            
            if (currentIndex === -1) {      
                newChecked.splice(0, checkedBase);
                Object.keys(listaServicios).map((keyCheck, value) => { 
                    newChecked.push(parseInt(value));
                })
            } else {
                newChecked.splice(0, checkedBase);
            }
        } else {          
            if (currentIndex === -1) {
                newChecked.push(parseInt(value));
                if ((checkedBase - 1) == newChecked.length )
                    newChecked.push(0)
            } else {
                newChecked.splice(currentIndex, 1);
                if (checked.indexOf(0) !== -1) {
                    newChecked.splice(newChecked.indexOf(0), 1);
                }            
            }

        }  
            
        let filteredSerie = [] 

        Object.keys(newChecked).map((keyCheck, value) => {

            let service = listaServicios[newChecked[parseInt(value)]]

            Object.keys(listaObjetivosOnline).map((keyObj, value) => {
                if (listaObjetivosOnline[keyObj].nombre_servicio_unificado == service) {
                    
                    filteredSerie.push(listaObjetivosOnline[keyObj])
                }    
            })  
        })
        filteredSerie.sort(function (a, b) {
            var priorityA = a.orden || Infinity;
            var priorityB = b.orden || Infinity;

            var nombreA = (a.nombre).toLowerCase()
            var nombreB = (b.nombre).toLowerCase()

            if (priorityA < priorityB) return -1;
            if (priorityA > priorityB) return 1;

            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        })
        if (checkedBase == newChecked.length) {
            check = false
        } else {
            check = true
        }

        this.setState({
            checked: newChecked,
            filteredListObjectives: filteredSerie,
            isBallotIconChecked: check
        });
    };

    toggleReport =()=>{
        if(sessionStorage.getItem("special")==="true"){
            sessionStorage.setItem("special", "false")
        }
        this.setState({
            special: !this.state.special,
            cargando:true
        });
    }
    

    render() {
        const { classes, className } = this.props;
        const { listaObjetivos, listaServicios, cargando, anchorEl, checked, filteredListObjectives, isBallotIconChecked, openModal, profileId, 
            special, listObjectivesSpecials,nameSide } = this.state
        const rootClassName = classNames(classes.root, className);
        const open = Boolean(anchorEl);
        const profileNoSpecial=[3,6,7,12]
        // console.log(filteredListObjectives)
        // console.log("profile", profileId, profileNoSpecial)
        // console.log(profileNoSpecial.includes(profileId))
        return (
            <nav className={rootClassName}>
                <div className={classes.logoWrapper}>
                    <Link
                        className={classes.logoLink}
                        to="/quickview"
                    >
                        <img
                            alt="Atentus logo"
                            className={classes.logoImage}
                            src="/images/logos/logo-atentus-gris.svg"
                        />
                    </Link>
                </div>
                <Divider className={classes.profileDivider} />
                <List
                    component="div"
                    disablePadding
                >
                    <ListItem
                        activeClassName={classes.activeListItem}
                        className={classes.listItem}
                        component={NavLink}
                        to={{
                            pathname: `/quickview`,
                            state: {
                                Graph:1
                            }
                        }}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Vista Rápida de Monitoreos"
                        />
                    </ListItem>
                    <ListItem
                        activeClassName={classes.activeListItem}
                        className={classes.listItem}
                        component={NavLink}
                        estado="dos"
                        to={{
                            pathname: `/estadoOperativo`,
                            state: {
                                Graph:2
                            }
                        }}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Estado Operativo"
                        />
                    </ListItem>
                   {/*  <ListItem
                        activeClassName={classes.activeListItem}
                        className={classes.listItem}
                        component={NavLink}
                        estado="tres"
                        to={{
                            pathname: `/summaryObjectives`,
                            state: {
                                Graph:3
                            }
                        }}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Estado de Monitoreos por Servicio"
                        />
                    </ListItem> */}
                    <ListItem
                        activeClassName={classes.activeListItem}
                        className={classes.listItem}
                        component={NavLink}
                        estado="cuatro"
                        to={{
                            pathname: `/generalStatus`,
                            state: {
                                Graph:4
                            }
                        }}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Estado General"
                        />
                    </ListItem>
                    <ListItem
                        activeClassName={classes.activeListItem}
                        className={classes.listItem}
                        component={NavLink}
                        to={{
                            pathname: `/quickviewisplights`,
                            state: {
                                Graph:1
                            }
                        }}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Vista Rápida por Isp / Semáforo"
                        />
                    </ListItem>
                    <ListItem
                        activeClassName={classes.activeListItem}
                        className={classes.listItem}
                        component={NavLink}
                        estado="cuatro"
                        to={{
                            pathname: `/comparisonObjectives`,
                            state: {
                                Graph:4
                            }
                        }}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Comparación de Objetivos"
                        />
                    </ListItem>

                    <Divider className={classes.listDivider} />

                    <List
                        component="div"
                        disablePadding
                        subheader={
                            <Grid
                                container
                                spacing={10}
                                className={classes.listItemIconFilter}
                            >
                                <Grid
                                    item
                                    xs={4}
                                    sm={4}
                                    md={4}
                                    xl={4}
                                >
                                    <ListSubheader className={classes.listSubheader}>
                                    {nameSide}
                                    </ListSubheader>
                                </Grid>
                                <Grid
                                    item
                                    xs={8}
                                    sm={8}
                                    md={8}
                                    xl={8}
                                >
                                    
                                    <Icon onClick={this.toggleReport} style={{ display:"inline-block", width:"35px"}}>
                                        {profileNoSpecial.includes(profileId)===false?
                                        special?
                                            <Tooltip title="Monitoreos" placement="top-start">
                                                <Typography style={{color:"white", fontSize:"18px", paddingTop:"3px"}}>M</Typography>
                                            </Tooltip>
                                            :
                                            <Tooltip title="Reportes Especiales" placement="top-start">
                                                <Typography style={{color:"white", fontSize:"18px", paddingTop:"3px"}}>R.E.</Typography>
                                            </Tooltip>
                                        :null
                                            
                                        }
                                    </Icon>

                                    <Tooltip title="Actualizar" placement="top-start">
                                        <UpdateIcon  variant="contained" onClick={this.handleClickUpdate} className={classes.ballotIcon} />
                                    </Tooltip>
                                    <Tooltip title="Ver resumen de Monitoreos" placement="top-start">
                                    <BarChartOutlinedIcon variant="contained" onClick={this.handleClickModal} className={classes.ballotIcon}/> 
                                    </Tooltip>
                                    <Tooltip title="Filtrar por servicio" placement="top-start">
                                    {isBallotIconChecked ? 
                                        <FilterListIcon variant="contained" onClick={this.handleClick} className={classes.ballotIconChecked}/> :
                                        <FilterListIcon variant="contained" onClick={this.handleClick} className={classes.ballotIcon}/>
                                    
                                    }
                                    </Tooltip>                                    
                                    <div>
                                        <Modal
                                            aria-labelledby="simple-modal-title"
                                            aria-describedby="simple-modal-description"
                                            open={openModal}
                                            onClose={this.handleCloseModal}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            disableAutoFocus={true}
                                            disableEnforceFocus={true}
                                            closeAfterTransition
                                            BackdropComponent={Backdrop}
                                            BackdropProps={{
                                                timeout: 500,
                                            }}
                                        >                                    
                                            <Fade in={openModal}>
                                                <PerfectScrollbar>
                                                <div className={classes.modal}>                             
                                                    <SummaryObjectives params={listaObjetivos} handleClose={this.handleCloseModal} isForModal={true}/>                        
                                                </div>
                                                </PerfectScrollbar>
                                            </Fade>
                                        </Modal>
                                    </div>
                                    
                                    <Popover open={open} onClose={this.handleClose}
                                            anchorReference="anchorPosition"
                                            anchorPosition={{ top: 170, left: 220 }}
                                          
                                            /*anchorOrigin={{
                                                vertical: 'center',
                                                horizontal: 'left',
                                              }}
                                              transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                              }}*/>
                                            <Paper style={{ minHeight: 50, 
                                                                maxHeight: 400, 
                                                                overflow: 'auto', 
                                                                backgroundColor: '#333333',
                                                        
                                                                }}
                                                                className={classes.customScrollBar}>
                                                <List   disablePadding>
                                                    {Object.keys(listaServicios).map(key => ( 
                                                            <ListItem
                                                                className={classes.listItem}
                                                                component="div"
                                                                key={key} 
                                                                role={undefined} 
                                                                dense button
                                                                onClick={this.handleToggle(key)}
                                                            >
                                                                <ListItemIcon className={classes.listItemIcon} >
                                                                    <Checkbox
                                                                        style ={{
                                                                            color: "#f57000",
                                                                        }}
                                                                        edge="start"
                                                                        checked={checked.indexOf(parseInt(key)) !== -1}
                                                                        tabIndex={-1}
                                                                        disableRipple
                                                                        inputProps={{ 'aria-labelledby': key }}
                                                                    />
                                                                </ListItemIcon>
                                                                <ListItemText classes={{ primary: classes.listItemText }} id={key} primary={listaServicios[key]} />                                                             
                                                            </ListItem>
                                                            
                                                    
                                                    ))}
                                                </List>
                                            </Paper>
                                    </Popover>
                                </Grid>                                
                            </Grid>                            
                        }
                    >
                        <Paper style={{ minHeight: 50, 
                                        maxHeight: 400, 
                                        overflow: 'auto', 
                                        overflowX: 'hidden',
                                        backgroundColor: '#333333',
                                       
                                    }}
                                className={classes.customScrollBar}>
                            {cargando ?
                                <div className={classes.profile}>
                                    <CircularProgress />
                                </div>
                                : 
                                special?
                                listObjectivesSpecials.map((keyObj) => (
                                    <ListItem
                                        key={keyObj.objetivo_id}
                                        className={classes.listItem}
                                        activeClassName={classes.activeListItem}
                                        component={NavLink}
                                        to={{
                                            pathname: `/especial/${keyObj.objetivo_id}/${keyObj.nombre}`,
                                            state: {
                                                fromObjective: keyObj
                                            }
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <TimelineIcon style={{color:"#3eeacc"}} />
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={keyObj.nombre}
                                            //Cambia estructura, para agregar estilo custom directo
                                            secondary={<div style={{ color: '#b2b2b2',  fontWeight: 'bold', }}>{keyObj.nombre_servicio}</div>}
                                        />
                                    </ListItem>
                                    ))
                                :
                                Object.keys(filteredListObjectives).map((keyObj, value) => (
                                    <ListItem
                                        key={filteredListObjectives[keyObj].objetivo_id}
                                        className={classes.listItem}
                                        activeClassName={classes.activeListItem}
                                        component={NavLink}
                                        to={{
                                            pathname: `/online/${filteredListObjectives[keyObj].objetivo_id}/${filteredListObjectives[keyObj].nombre}/${filteredListObjectives[keyObj].nombre_servicio_unificado}`,
                                            state: {
                                                fromObjective: filteredListObjectives[keyObj]
                                            }
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <TimelineIcon style={{color:filteredListObjectives[keyObj].color}} />
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={filteredListObjectives[keyObj].nombre}
                                            //Cambia estructura, para agregar estilo custom directo
                                            secondary={<div style={{ color: '#b2b2b2',  fontWeight: 'bold', }}>{filteredListObjectives[keyObj].nombre_servicio_unificado}</div>}
                                        />
                                    </ListItem>
                                ))
                            }
                        </Paper>
                    </List>
                </List>
                <Divider className={classes.listDivider} />
                <List
                    component="div"
                    disablePadding
                    subheader={
                        <ListSubheader className={classes.listSubheader}>
                            Soporte y Herramientas
                        </ListSubheader>
                    }
                >
                    <ListItem
                        activeClassName={classes.activeListItem}
                        className={classes.listItem}
                        component={NavLink}
                        to="/manageObjectives"
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <SettingsOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Configurar Objetivos"
                        />
                    </ListItem>
                    <ListItem
                        activeClassName={classes.activeListItem}
                        className={classes.listItem}
                        component={NavLink}
                        to="/settings"
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <SettingsOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Administración"
                        />
                        
                    </ListItem>
                    {profileId == 1 ?
                    <ListItem
                        activeClassName={classes.activeListItem}
                        className={classes.listItem}
                        component={NavLink}
                        title="Mantenimientos"
                        to="/Maintenance"
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <SettingsOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Mantenimientos"
                        />
                        
                    </ListItem>
                    :null}

                  {/*   <ListItem
                        className={classes.listItem}
                        component="a"
                        href="https://www.atentus.com/contacto-atentus/"
                        target="_blank"
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <InfoIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Contacte a un Ejecutivo"
                        />
                    </ListItem> */}
                </List>
                <Divider className={classes.listDivider} />

            </nav>
        );

    }
}

Sidebar.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default compose(
    withRouter,
    withStyles(styles)
)(Sidebar);
